module.exports = __webpack_public_path__ + "img/message-check.122837a3.svg";